import { createSlice } from '@reduxjs/toolkit';

const exchangeRateSlice = createSlice({
  name: 'exchangeRate',
  initialState: {
    isLoading: false,
    error: null,
    price: ''
  },
  reducers: {
    //Get Exchange rate
    updateExchangeRate: state => {
      state.isLoading = true;
      state.error = null;
    },
    updateExchangeRateSuccess: (state, action) => {
      state.price = action.payload;
      state.isLoading = false;
    },

    updateExchangeRateFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    }
  }
});

export const {
  updateExchangeRate,
  updateExchangeRateSuccess,
  updateExchangeRateFailure
} = exchangeRateSlice.actions;

export default exchangeRateSlice.reducer;
